import { store } from "react-notifications-component";

const animationIn = ["animate__animated", "animate__fadeIn"];
const animationOut = ["animate__animated", "animate__fadeOut"];
const dismiss = {
  showIcon: true,
  duration: 4000,
};
const insert = "top";
const container = "top-center";

interface alertParam {
  msg?: string;
  statusCode?: number;
}

export function success(param: alertParam) {
  store.addNotification({
    title: "Success!",
    message: param.msg,
    type: "success",
    insert: insert,
    container: container,
    animationIn: animationIn,
    animationOut: animationOut,
    dismiss: dismiss,
  });
}

export function info(param: alertParam) {
  store.addNotification({
    title: "Info",
    message: param.msg,
    type: "info",
    insert: insert,
    container: container,
    animationIn: animationIn,
    animationOut: animationOut,
    dismiss: dismiss,
  });
}

export function defaultNotif(param: alertParam) {
  store.addNotification({
    title: "Notification",
    message: param.msg,
    type: "default",
    insert: insert,
    container: container,
    animationIn: animationIn,
    animationOut: animationOut,
    dismiss: dismiss,
  });
}

export function warning(param: alertParam) {
  store.addNotification({
    title: "Warning",
    message: param.msg,
    type: "warning",
    insert: insert,
    container: container,
    animationIn: animationIn,
    animationOut: animationOut,
    dismiss: dismiss,
  });
}

export function danger(param: alertParam) {
  if (!param.msg) {
    param.msg = `Something went wrong. Please try again later. [${param.statusCode}]`;
  }
  store.addNotification({
    title: "Error",
    message: param.msg,
    type: "danger",
    insert: insert,
    container: container,
    animationIn: animationIn,
    animationOut: animationOut,
    dismiss: dismiss,
  });
}

export const alertService = {
  success,
  info,
  defaultNotif,
  warning,
  danger,
};
